var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhlanBarCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "266px",
    height: "92px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 266 92",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "translate(0,0)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 266,
    height: 92,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 10)",
    style: {
      fill: "#000000"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4,
    height: 50
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0,
    width: 2,
    height: 50
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 6,
    height: 50
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 0,
    width: 4,
    height: 50
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 0,
    width: 2,
    height: 50
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 0,
    width: 2,
    height: 50
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 0,
    width: 2,
    height: 50
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 0,
    width: 4,
    height: 50
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 0,
    width: 2,
    height: 50
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 0,
    width: 2,
    height: 50
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 0,
    width: 4,
    height: 50
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 0,
    width: 6,
    height: 50
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 0,
    width: 2,
    height: 50
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 0,
    width: 4,
    height: 50
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 0,
    width: 2,
    height: 50
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 0,
    width: 2,
    height: 50
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 0,
    width: 4,
    height: 50
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 0,
    width: 2,
    height: 50
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 0,
    width: 8,
    height: 50
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 0,
    width: 2,
    height: 50
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 0,
    width: 2,
    height: 50
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 0,
    width: 4,
    height: 50
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 0,
    width: 2,
    height: 50
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 0,
    width: 2,
    height: 50
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 0,
    width: 4,
    height: 50
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 0,
    width: 6,
    height: 50
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 0,
    width: 2,
    height: 50
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 0,
    width: 2,
    height: 50
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 0,
    width: 4,
    height: 50
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 0,
    width: 6,
    height: 50
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 0,
    width: 4,
    height: 50
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 0,
    width: 6,
    height: 50
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 0,
    width: 2,
    height: 50
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 0,
    width: 4,
    height: 50
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      font: "20px monospace"
    },
    textAnchor: "middle",
    x: 123,
    y: 72
  }, "0971127070977522")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhlanBarCode);
export default __webpack_public_path__ + "static/media/ahlanBarCode.fb2d0506c3d6c37bfc8cdfe06f0dee12.svg";
export { ForwardRef as ReactComponent };